import { ThemeColorVariable } from "@caspeco/casper-ui-library";

export function cssVarToRgba(value: string | ThemeColorVariable, alpha: number = 1): string {
    let resolvedValue = String(value);

    // If it's in var(--something) format, resolve it
    const varMatch = resolvedValue.match(/^var\((--[^)]+)\)$/);
    if (varMatch) {
        resolvedValue = getComputedStyle(document.documentElement)
            .getPropertyValue(varMatch[1])
            .trim();
    }

    if (!resolvedValue) {
        throw new Error(`CSS variable could not be resolved`);
    }

    // Handle hex (#RGB, #RRGGBB)
    if (resolvedValue.startsWith("#")) {
        let hex = resolvedValue.slice(1);
        if (hex.length === 3) {
            hex = hex
                .split("")
                .map((ch: string) => ch + ch)
                .join("");
        }
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // Handle rgb()/rgba()
    if (resolvedValue.startsWith("rgb")) {
        const matches = resolvedValue.match(/[\d.]+/g);
        if (!matches) {
            throw new Error(`Invalid rgb format: ${resolvedValue}`);
        }
        const parts = matches.map(Number);
        const [r, g, b, a = 1] = parts;
        return `rgba(${r}, ${g}, ${b}, ${alpha * a})`;
    }

    throw new Error(`Unsupported color format: ${resolvedValue}`);
}
